import { Expose, Type } from '@nts/std/serialization';
import { ZoomIdentity } from "../zoom.identity";

export class PinZoomToDashboardDto {
    
    @Expose()
    @Type(() => ZoomIdentity)
    zoomIdentity: ZoomIdentity;
}